import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyDQVYmj7IRK-QY_lqnyxSnfkBRK6zLdeU4",
//   authDomain: "givesome-payment-web.firebaseapp.com",
//   projectId: "givesome-payment-web",
//   storageBucket: "givesome-payment-web.firebasestorage.app",
//   messagingSenderId: "880856268943",
//   appId: "1:880856268943:web:78cc7546863982f4c4b0fa"
// };

const firebaseConfig = {

  apiKey: "AIzaSyBf4voaXCgyU1f4Sv5Q2CYTfp9sWWfPpVU",

  authDomain: "givesome-qa-38172.firebaseapp.com",

  databaseURL: "https://givesome-qa-38172-default-rtdb.firebaseio.com",

  projectId: "givesome-qa-38172",

  storageBucket: "givesome-qa-38172.firebasestorage.app",

  messagingSenderId: "67899292542",

  appId: "1:67899292542:web:6f478ef369dd251009112f"

};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
